import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartSeries,
  ChartSeriesItem,
} from '@progress/kendo-react-charts';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMount from '../../../../../../common/hooks/useMount';
import { MostViewedProductsItemModel } from '../../../../models/analytics';
import { resources } from '../../../../resources/resources';
import { analyticsService } from '../../../../services/analytics';
import { formatLabel } from '../utils';

export const MostViewedProductsChart = () => {
  const [mostViewedProducts, setMostViewedProducts] = useState<
    MostViewedProductsItemModel[]
  >([]);
  const { t: translate } = useTranslation();

  const loadMostViewedProducts = async (abortController?: AbortController) => {
    const resp = await analyticsService.getMostViewedProducts({
      signal: abortController?.signal,
    });
    if (abortController?.signal.aborted) return;
    if (!resp.hasErrors) {
      setMostViewedProducts(resp.data);
    }
  };

  useMount(loadMostViewedProducts);

  return (
    <div className="m-panel m-analytics-panel">
      <h2>{translate(resources.analytics.charts.mostViewed)}</h2>
      <Chart style={{ height: 300 }} transitions={false}>
        <ChartSeries>
          <ChartSeriesItem
            type="bar"
            color="#ff220d"
            tooltip={{
              visible: true,
            }}
            data={mostViewedProducts}
            field="value"
            categoryField="name"
          />
        </ChartSeries>
        <ChartCategoryAxis>
          <ChartCategoryAxisItem
            majorGridLines={{ visible: false }}
            labels={{
              content: e => formatLabel(e.value, 8),
            }}
          ></ChartCategoryAxisItem>
        </ChartCategoryAxis>
      </Chart>
    </div>
  );
};
